import React, { useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const OtpScreen = () => {
  const [otp, setOtp] = useState(["", "", "", ""]);
  const navigate = useNavigate();
  const inputRefs = useRef([]);
  const { state } = useLocation();
  const { otpData } = state || {};
  const [loader, setLaoder] = useState(false);


  const handleChange = (element, index) => {
    if (isNaN(element.value)) return;
    const newOtp = [...otp];
    newOtp[index] = element.value;
    setOtp(newOtp);
    if (element.value && inputRefs.current[index + 1]) {
      inputRefs.current[index + 1].focus();
    }
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index] === "" && inputRefs.current[index - 1]) {
        inputRefs.current[index - 1].focus();
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const finalOtp = otp.join("");
    if (finalOtp.length !== 4) {
      alert("Please enter a 4-digit OTP.");
      return;
    }
    setLaoder(true)
    if (finalOtp === otpData?.otp) {
      toast.success("OTP Verified Successfully!", {
        position: "top-right",
        autoClose: 2000,
        style: {
          backgroundColor: "#d0d3d4 ",
          color: "black",
          fontWeight: "bold",
        },
      });
      setLaoder(false)
      navigate("/Address");
    } else {
      setLaoder(false)
      toast.error(
        "Invalid OTP",
        "The OTP entered is incorrect. Please try again.",
        {
          position: "top-right",
          autoClose: 2000,
          style: {
            backgroundColor: "#d0d3d4 ",
            color: "black",
            fontWeight: "bold",
          },
        }
      );
    }
  };

  return (
    <div className="min-h-screen bg-red-100 flex items-center justify-center bg-gradient-to-br sm:from-pink-50 via-blue-200 to-white py-10">
      <form
        onSubmit={handleSubmit}
        className="bg-white rounded-2xl shadow-lg max-w-md p-5 space-y-8 sm:w-full"
      >
        <div className="text-center">
          <h2 className="text-3xl font-bold text-gray-800">Enter OTP</h2>
          <p className="text-gray-600 mt-2">
            We have sent a 4-digit OTP to your phone.
          </p>
        </div>
        <div className="flex justify-between space-x-2">
          {otp.map((data, index) => (
            <input
              key={index}
              type="text"
              maxLength="1"
              value={otp[index]}
              onChange={(e) => handleChange(e.target, index)}
              onKeyDown={(e) => handleKeyDown(e, index)}
              onFocus={(e) => e.target.select()}
              ref={(el) => (inputRefs.current[index] = el)}
              className="w-12 h-12 text-center border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 text-xl"
              required
            />
          ))}
        </div>
        <button
          type="submit"
          className="w-full py-2 px-4 bg-indigo-600 text-white font-semibold rounded-lg hover:bg-indigo-700"
        >
          Verify OTP
        </button>
        <div className="text-center">
          <p className="text-sm text-gray-600">
            Didn't receive the code?{" "}
            <button
              type="button"
              className="text-indigo-600 hover:underline"
              onClick={() => alert("Resend OTP logic here")}
            >
              Resend
            </button>
          </p>
        </div>
      </form>
    </div>
  );
};
export default OtpScreen;
